import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { IServer } from '../server.interface';
import { serverStoreSelector } from '../server.selector';

export const serverListSelector = createCachedSelector(
  [
    path(serverStoreSelector).data(),
    path(serverStoreSelector).listNetworkStatus(),
  ],
  (data, networkStatus) => {
    // Stub entries without serverId may appear when load.started/failed lands after the store was destroyed.
    const list: IServer[] = Object.values(data).filter((server) => Boolean(server.serverId));
    return {
      list,
      networkStatus,
    };
  },
)({
  keySelector: defaultKeySelector,
});
